<template>
  <div v-show="isLoading" class="absolute top-20 w-full">
    <div class="my-5 py-4 text-center">
      <div class="space-x-2">
        <template v-for="(_n, i) in 5" :key="_n">
          <DsIcon
            class="animate-pulse text-blue-700"
            name="circle"
            :class="`opacity-${100 - 20 * i}`"
          >
          </DsIcon>
        </template>
      </div>
      <p v-if="takesTooLong" class="lead mt-3">Daten werden geladen...</p>
      <p v-else class="lead mt-3">Sie werden eingeloggt...</p>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { DsIcon } from '@demvsystems/design-components';
import { ref, watch } from 'vue';

interface Props {
  isLoading: boolean;
}

const props = defineProps<Props>();

let timer: null | ReturnType<typeof setTimeout> = null;
const takesTooLong = ref(false);

watch(
  () => props.isLoading,
  () => {
    takesTooLong.value = false;
    if (timer !== null) {
      clearTimeout(timer);
    }

    if (props.isLoading) {
      timer = setTimeout(() => {
        takesTooLong.value = true;
      }, 5000);
    }
  },
  {
    immediate: true,
  },
);
</script>

<script lang="ts">
export default {
  name: 'LoadingView',
};
</script>
